import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core'
import { MatColumnDef, MatTable } from '@angular/material/table'

import { TableColumnSize } from '@shared/models/table-column-size'

@Directive()
export abstract class AbstractColumn implements OnInit, OnDestroy {
  @Input() name: string
  @Input() size: TableColumnSize = TableColumnSize.Small

  @ViewChild(MatColumnDef, { static: true }) columnDef: MatColumnDef

  constructor(
    @Optional() public table: MatTable<any>,
    public changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.table && this.table.addColumnDef(this.columnDef)
    this.columnDef.name = this.name
    this.columnDef.cssClassFriendlyName = this.size
    this.changeDetectorRef.detectChanges()
  }

  ngOnDestroy() {
    this.table && this.table.removeColumnDef(this.columnDef)
  }
}
